import { render, staticRenderFns } from "./Guia_Remision.vue?vue&type=template&id=37388b95&scoped=true"
import script from "./Guia_Remision.vue?vue&type=script&lang=js"
export * from "./Guia_Remision.vue?vue&type=script&lang=js"
import style0 from "./Guia_Remision.vue?vue&type=style&index=0&id=37388b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37388b95",
  null
  
)

export default component.exports